'use strict';
import $ from 'jquery';
import Swal from 'sweetalert2';

const lang = document.documentElement.lang;

const tr = {
  'pt-BR': {
    modal_error_attention: 'Atenção!',
    modal_error_invite: 'Erro ao enviar convite! Tente novamente mais tarde.',
    modal_success_invite: 'Convite enviado com sucesso!',
    modal_success_invitemsg:
      'O usuário deverá realizar um cadastro na plataforma para contabilizar a pontuação da sua equipe.',
  },
  en: {
    modal_error_attention: 'Attention!',
    modal_error_invite: 'Error sending invitation! Try again later.',
    modal_success_invite: 'Invitation sent successfully!',
    modal_success_invitemsg: "The user must register on the platform to count your team's score.",
  },
  es: {
    modal_error_attention: '¡Atención!',
    modal_error_invite: '¡Error al enviar la invitación! Vuelve a intentarlo más tarde.',
    modal_success_invite: '¡Invitación enviada exitosamente!',
    modal_success_invitemsg:
      'El usuario deberá registrarse en la plataforma para registrar la puntuación de su equipo.',
  },
};

export const profileInvites = () => {
  const $inviteModal = $('.js-invite-modal');

  $('.js-invite-btn').on('click', function (e) {
    e.preventDefault();
    $inviteModal.addClass('is-active');
  });

  $('.js-invite-cancel').on('click', function (e) {
    e.preventDefault();
    $inviteModal.removeClass('is-active');
  });

  $('#form-invite').on('submit', function (e) {
    e.preventDefault();

    const $inviteEmail = $('.js-invite-email');
    const url = $(this).attr('action');
    const email = $inviteEmail.val();
    const _token = $('meta[name="csrf-token"]').attr('content');

    $.ajax({
      url,
      type: 'POST',
      data: {
        email,
        _token,
      },
      dataType: 'json',
      success: function (data) {
        if (data.success) {
          Swal.fire(tr[lang].modal_success_invite, tr[lang].modal_success_invitemsg, 'success');
        } else {
          Swal.fire(tr[lang].modal_error_attention, data.message, 'warning');
        }
      },
      error: function (xhr, status, error) {
        Swal.fire(tr[lang].modal_error_attention, tr[lang].modal_error_invite, 'warning');
        console.error('AJAX request failed:', status, error);
      },
      complete: function () {
        $inviteEmail.val('');
      },
    });
  });
};
